"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = require("immutable");

var _netlifyCmsUiDefault = require("netlify-cms-ui-default");

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

const FileLink = (
/*#__PURE__*/
0, _styledBase.default)((_ref) => {
  let {
    value: href,
    path
  } = _ref;
  return (0, _core.jsx)("a", {
    href: href,
    rel: "noopener noreferrer",
    target: "_blank"
  }, path);
}, {
  target: "e1sxjo0z0",
  label: "FileLink"
})(process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9GaWxlUHJldmlldy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFVRSIsImZpbGUiOiIuLi8uLi9zcmMvRmlsZVByZXZpZXcuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IExpc3QgfSBmcm9tICdpbW11dGFibGUnO1xuaW1wb3J0IHsgV2lkZ2V0UHJldmlld0NvbnRhaW5lciwgQXNzZXQgfSBmcm9tICduZXRsaWZ5LWNtcy11aS1kZWZhdWx0JztcblxuY29uc3QgRmlsZUxpbmsgPSBzdHlsZWQoKHsgdmFsdWU6IGhyZWYsIHBhdGggfSkgPT4gKFxuICA8YSBocmVmPXtocmVmfSByZWw9XCJub29wZW5lciBub3JlZmVycmVyXCIgdGFyZ2V0PVwiX2JsYW5rXCI+XG4gICAge3BhdGh9XG4gIDwvYT5cbikpYFxuICBkaXNwbGF5OiBibG9jaztcbmA7XG5cbmNvbnN0IEZpbGVMaW5rQXNzZXQgPSAoeyB2YWx1ZSwgZ2V0QXNzZXQgfSkgPT4ge1xuICByZXR1cm4gPEFzc2V0IHBhdGg9e3ZhbHVlfSBnZXRBc3NldD17Z2V0QXNzZXR9IGNvbXBvbmVudD17RmlsZUxpbmt9IC8+O1xufTtcblxuZnVuY3Rpb24gRmlsZUxpbmtMaXN0KHsgdmFsdWVzLCBnZXRBc3NldCB9KSB7XG4gIHJldHVybiAoXG4gICAgPGRpdj5cbiAgICAgIHt2YWx1ZXMubWFwKHZhbHVlID0+IChcbiAgICAgICAgPEZpbGVMaW5rQXNzZXQga2V5PXt2YWx1ZX0gdmFsdWU9e3ZhbHVlfSBnZXRBc3NldD17Z2V0QXNzZXR9IC8+XG4gICAgICApKX1cbiAgICA8L2Rpdj5cbiAgKTtcbn1cblxuZnVuY3Rpb24gRmlsZUNvbnRlbnQoeyB2YWx1ZSwgZ2V0QXNzZXQgfSkge1xuICBpZiAoQXJyYXkuaXNBcnJheSh2YWx1ZSkgfHwgTGlzdC5pc0xpc3QodmFsdWUpKSB7XG4gICAgcmV0dXJuIDxGaWxlTGlua0xpc3QgdmFsdWVzPXt2YWx1ZX0gZ2V0QXNzZXQ9e2dldEFzc2V0fSAvPjtcbiAgfVxuICByZXR1cm4gPEZpbGVMaW5rQXNzZXQgdmFsdWU9e3ZhbHVlfSBnZXRBc3NldD17Z2V0QXNzZXR9IC8+O1xufVxuXG5jb25zdCBGaWxlUHJldmlldyA9IHByb3BzID0+IChcbiAgPFdpZGdldFByZXZpZXdDb250YWluZXI+e3Byb3BzLnZhbHVlID8gPEZpbGVDb250ZW50IHsuLi5wcm9wc30gLz4gOiBudWxsfTwvV2lkZ2V0UHJldmlld0NvbnRhaW5lcj5cbik7XG5cbkZpbGVQcmV2aWV3LnByb3BUeXBlcyA9IHtcbiAgZ2V0QXNzZXQ6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG4gIHZhbHVlOiBQcm9wVHlwZXMubm9kZSxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEZpbGVQcmV2aWV3O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

const FileLinkAsset = (_ref2) => {
  let {
    value,
    getAsset
  } = _ref2;
  return (0, _core.jsx)(_netlifyCmsUiDefault.Asset, {
    path: value,
    getAsset: getAsset,
    component: FileLink
  });
};

function FileLinkList(_ref3) {
  let {
    values,
    getAsset
  } = _ref3;
  return (0, _core.jsx)("div", null, values.map(value => (0, _core.jsx)(FileLinkAsset, {
    key: value,
    value: value,
    getAsset: getAsset
  })));
}

function FileContent(_ref4) {
  let {
    value,
    getAsset
  } = _ref4;

  if (Array.isArray(value) || _immutable.List.isList(value)) {
    return (0, _core.jsx)(FileLinkList, {
      values: value,
      getAsset: getAsset
    });
  }

  return (0, _core.jsx)(FileLinkAsset, {
    value: value,
    getAsset: getAsset
  });
}

const FilePreview = props => (0, _core.jsx)(_netlifyCmsUiDefault.WidgetPreviewContainer, null, props.value ? (0, _core.jsx)(FileContent, props) : null);

FilePreview.propTypes = {
  getAsset: _propTypes.default.func.isRequired,
  value: _propTypes.default.node
};
var _default = FilePreview;
exports.default = _default;